module.exports = __webpack_public_path__ + "img/Kc.d3b03725.png";